<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>PKWT</h3>
                <div class="font-medium text-500 mb-3">
                    Rincian Perjanjian Kerja Waktu Tertentu
                </div>
                <div v-if="isEdit" class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >No PKWT</label
                    >
                    <InputText
                        id="is_present"
                        v-model="form.pkwt_no"
                        name="is_present"
                    />
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >PKWT Date</label
                    >
                    <Calendar
                        :showIcon="true"
                        :showButtonBar="true"
                        :class="{
                            'p-invalid': submitted && !form.pkwt_date,
                        }"
                        v-model="form.pkwt_date"
                        dateFormat="yy-mm-dd"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !form.pkwt_date"
                        >PKWT Date is required.</small
                    >
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >{{ $t("start-date") }}</label
                    >
                    <Calendar
                        :showIcon="true"
                        :showButtonBar="true"
                        :class="{
                            'p-invalid': submitted && !form.start_date,
                        }"
                        v-model="form.start_date"
                        dateFormat="yy-mm-dd"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !form.start_date"
                        >{{ $t("start-date") }} is required.</small
                    >
                    <div class="col-12 mt-1 md:col-2 font-medium">
                        <label for="name3">{{ $t("end-date") }}</label>
                    </div>
                    <Calendar
                        :showIcon="true"
                        :showButtonBar="true"
                        :class="{
                            'p-invalid': submitted && !form.end_date,
                        }"
                        v-model="form.end_date"
                        dateFormat="yy-mm-dd"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !form.end_date"
                        >{{ $t("end-date") }} is required.</small
                    >
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Nama Karyawan</label
                    >
                    <AutoComplete
                        forceSelection
                        placeholder="Search"
                        id="dd"
                        :dropdown="true"
                        v-model="selectedEmployee"
                        :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)"
                        @item-select="selectApprovedBy"
                        field="name"
                        :class="{
                            'p-invalid': submitted && !selectedEmployee,
                        }"
                    />
                    <small
                        class="p-invalid"
                        v-if="submitted && !selectedEmployee"
                    >
                        Employee is required.
                    </small>
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >Penempatan</label
                    >
                    <Dropdown
                        v-model="form.placement_id"
                        :options="placements"
                        optionLabel="name"
                        optionValue="id"
                        placeholder="Select Placement"
                    />
                </div>
                <div class="field grid">
                    <label for="name3" class="col-12 mb-2 md:col-3 md:mb-0 font-medium">Gaji</label>
                    <InputNumber id="fee" mode="decimal" locale="id-ID" v-model="form.salary"/>
                </div>
                <div class="field grid">
                    <label
                        for="name3"
                        class="col-12 mb-2 md:col-3 md:mb-0 font-medium"
                        >PIC</label
                    >
                    <AutoComplete
                        forceSelection
                        placeholder="Search"
                        id="dd"
                        :dropdown="true"
                        v-model="selectedPic"
                        :suggestions="autoFilteredValue"
                        @complete="searchEmployee($event)"
                        @item-select="selectPicId"
                        field="name"
                        :class="{ 'p-invalid': submitted && !selectedPic }"
                    />
                    <small class="p-invalid" v-if="submitted && !selectedPic">
                        PIC is required.
                    </small>
                </div>
                <Button
                    :loading="isSaving"
                    @click="save"
                    id="button1"
                    label="Save"
                />
            </div>
        </div>
    </div>
</template>
<script>
import AppLayoutVue from "../../../Layouts/AppLayout.vue";
import AutoComplete from "primevue/autocomplete";
import Button from "primevue/button";
import Calendar from "primevue/calendar";
import Checkbox from "primevue/checkbox";
import Dropdown from "primevue/dropdown";
import InputText from "primevue/inputtext";
import InputNumber from "primevue/inputnumber";
import Textarea from "primevue/textarea";
import axios from "axios";

export default {
    layout: AppLayoutVue,
    components: {
        AutoComplete,
        Button,
        Calendar,
        Checkbox,
        Dropdown,
        InputText,
        InputNumber,
        Textarea,
    },
    data() {
        return {
            form: this.$page.props.contract ?? { },
            placements: {},
            positions: {},
            submitted: false,
            autoFilteredValue: [],
            selectedEmployee: this.$page.props.contract
                ? this.$page.props.contract.employee
                : "",
            selectedPic: this.$page.props.contract
                ? this.$page.props.contract.pic
                : "",
            isEdit: this.$page.props.contract ? true : false,
            isSaving: false,
        };
    },
    computed: {
        totalFee() {
            return (this.form.amount * 8.5) / 100;
        },
    },
    mounted() {
        this.initData();
    },
    methods: {
        searchEmployee(event) {
            setTimeout(() => {
                if (!event.query.trim().length) {
                    axios
                        .get(`${this.$page.props.appUrl}api/employees`)
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                } else {
                    let filterValue = event.query.toLowerCase();
                    axios
                        .get(
                            `${this.$page.props.appUrl}api/employees?search=${filterValue}`
                        )
                        .then((data) => {
                            this.autoFilteredValue = data.data.data;
                        });
                }
            }, 250);
        },
        selectApprovedBy() {
            axios
                .get(
                    `${this.$page.props.appUrl}api/employees/${this.selectedEmployee.id}`
                )
                .then((data) => {
                    this.form.employee_id = this.selectedEmployee.id;
                });
        },
        selectPicId() {
            axios
                .get(
                    `${this.$page.props.appUrl}api/employees/${this.selectedPic.id}`
                )
                .then((data) => {
                    this.form.pic_id = this.selectedPic.id;
                });
        },
        initData() {
            axios
                .get(`${this.$page.props.appUrl}api/placement-units`)
                .then((data) => {
                    this.placements = data.data;
                })
                .catch((error) => {
                    this.$toast.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                        life: 3000,
                    });
                });
            axios
                .get(`${this.$page.props.appUrl}api/positions`)
                .then((data) => {
                    this.positions = data.data;
                });
        },
        clearForm() {
            this.form = {
                mistakes:
                    "Pembayaran Tagihan Tenaga Security Sebanyak xx orang (Anggota) Periode :xx - xx November 2022",
            };
            this.selectedEmployee = "";
        },
        save() {
            this.isSaving = true;
            this.submitted = true;

            if (this.isEdit) {
                axios
                    .put(
                        `${this.$page.props.appUrl}api/letters/contracts/${this.$page.props.contract.id}`,
                        this.form
                    )
                    .then((data) => {
                        this.clearForm();
                        this.submitted = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Contract Updated",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Updating Contract",
                            detail: error,
                            life: 3000,
                        });
                    });
            } else {
                axios
                    .post(
                        `${this.$page.props.appUrl}api/letters/contracts`,
                        this.form
                    )
                    .then((data) => {
                        this.clearForm();
                        this.submitted = false;

                        this.$toast.add({
                            severity: "success",
                            summary: "Successful",
                            detail: "Contract Created",
                            life: 3000,
                        });
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error When Creating Contract",
                            detail: error,
                            life: 3000,
                        });
                    });
            }

            this.isSaving = false;
        },
    },
};
</script>
